// extracted by mini-css-extract-plugin
module.exports = {"container":"edit-control-supervisor_container__2kxw_","floatingBar":"edit-control-supervisor_floatingBar__1yMlP","fadeIn":"edit-control-supervisor_fadeIn__2VLSU"};